import { gql } from 'graphql-tag'

export const FRAGMENT_MESSAGE_EMBED_V1_MESSAGE = gql`
  fragment MessageEmbedV1Message on message {
    id
    type
    body_safe

    user {
      id
      virtual_display_name
      virtual_avatar_url
      virtual_progression_points
    }
  }
`
